import React, { useCallback, useState } from 'react';

import { Trans, useTranslation } from 'react-i18next';

import { ContactUsModal } from '../../../sideMenu/contactUs/ContactUsModal';
import { CONTACT_US_STEPS }
from '../../../sideMenu/contactUs/contactUs.constants';

import '../css/CancelRenewalSent.css';

const CancelRenewalSent = ({ onReturnClick = () => { } }) => {
  const { t } = useTranslation('changeCoverage');
  const [contactUsVisible, setContactUsVisible] = useState(false);

  const onContactUsClick = useCallback(() => {
    setContactUsVisible((prevState) => !prevState);
  }, []);

  const ContactUsButton = () => (
    <button
      className="Cancel-renewal-sent-contact-us"
      onClick={onContactUsClick}
      type="button"
    >
      <span>{t('options.cancelRenewalContactUs')}</span>
    </button>
  );

  return (
    <>
      <div className="Cancel-renewal-sent-container">
        <h3>{t('options.cancelRenewalSent')}</h3>

        <div className="Cancel-renewal-sent-description">
          <Trans
            components={{ button: <ContactUsButton /> }}
            i18nKey="options.cancelRenewalSentDescription"
            t={t}
          />
        </div>

        <button
          className="Cancel-renewal-sent-return-btn"
          onClick={onReturnClick}
          type="button"
        >
          {t('preview.returnToInsurance')}
        </button>
      </div>

      <ContactUsModal
        companyStep={CONTACT_US_STEPS.FIGO}
        onClose={onContactUsClick}
        show={contactUsVisible}
      />
    </>
  );
};

export { CancelRenewalSent };
